//check if email is valid es: test@email.com
export const emailValidationString =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const CHANNELS = [
  {
    id: 'EMAIL',
    label: 'EMAIL',
  },
  {
    id: 'SMS',
    label: 'SMS',
  },
  { id: 'BOTH', label: 'BOTH' },
];
